import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Layout from '@components/lpc/Layout/Layout';
import Hero from '@components/lpc/SolidarityLanding/Hero/Hero';
import NewsLetter from '@components/lpc/SolidarityLanding/NewsLetter/NewsLetter';
import PoolCreation from '@components/lpc/SolidarityLanding/PoolCreation/PoolCreation';
import Pools from '@components/lpc/SolidarityLanding/Pools/Pools';
import SubNav from '@components/lpc/SolidarityLanding/SubNav/SubNav';
import solidarityPoolService from '@services/domain/Lpc/SolidarityPoolService';
import { isInternalServerError } from '@services/http/Http';
import Custom500 from 'pages/500';

import css from './SolidarityPage.module.scss';

type SolidarityPageProps = {
    internalError: boolean;
    solidarityPoolsList: any;
};

const SolidarityPage = ({ solidarityPoolsList, internalError }: SolidarityPageProps) => {
    const { t } = useTranslateLpc('lpc-solidarity-page');
    if (internalError || !solidarityPoolsList) {
        return <Custom500 />;
    }
    return (
        <>
            <Layout
                isHomePage
                hideBorder
                ogTitle={t('meta-title')}
                ogDescription={t('meta-desc')}
                metaTitle={t('meta-title')}
                metaDescription={t('meta-desc')}
            >
                <div className={css.solidarity_page_container}>
                    <SubNav />
                    <Hero />
                    <Pools solidarityPoolsList={solidarityPoolsList} />
                    {/* <Articles/> */}
                    <PoolCreation />
                    <NewsLetter />
                </div>
            </Layout>
        </>
    );
};
export default SolidarityPage;

export const getServerSideProps = async () => {
    let internalError = false;
    const solidarityPoolsList = await solidarityPoolService.getPots().catch((err) => {
        internalError = isInternalServerError(err);
    });

    return {
        props: {
            solidarityPoolsList: solidarityPoolsList || {},
            internalError,
        },
    };
};
